import * as Rx from 'rxjs/Rx';

export class Pslistener {
    static i18n = {
        subject: new Rx.Subject(),
        next: o => Pslistener.i18n.subject.next(o),
        subscribe: cb => Pslistener.i18n.subject.subscribe(v => cb(v))
    };

    static appUserEdit = {
        dialog: null
    };
}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/pf.core/listener/Pslistener.ts